const t = {
  name: "Timer",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7V11.5858L15.4142 14L14 15.4142L11 12.4142V7H13Z" fill="currentColor"/>
<path d="M16 0H8V2H11V3.05493C6.50005 3.55237 3 7.36745 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.36745 17.5 3.55237 13 3.05493V2H16V0ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z" fill="currentColor"/>
<path d="M22.6066 5.63604L18.3639 1.3934L16.9497 2.80762L21.1923 7.05026L22.6066 5.63604Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Timer
};
